import React from 'react';

const Button = (props) => {
  const {f, bg, textColor, ...rest} = props;

  const originalClassName = props.className || '';
  let className = `f${f} link dim br2 ba ph3 pv2 mb2 dib pointer ${textColor} ${originalClassName}`;

  if (bg) {
    className += ` bg-${bg}`;
  }

  if (typeof props.children === 'string') {
    return (
      <a {...rest} className={className} >{props.children}</a>
    )
  } else {
    return React.cloneElement(props.children, {
      ...props.children.props,
      className
    })
}
}

Button.defaultProps = {
  f: '6',
  bg: 'black',
  textColor: 'white'
}

export default Button;


/** WEBPACK FOOTER **
 ** ./src/components/Button.js
 **/